var $plp = {
    filter_menu_close: '.filter-menu-close, .filter-menu-cta-close'
};

window.onload = (event) => {
    update_filter_dom();
};

$(document).ready(() => {
    listeners(); 
});

function listeners() {
    $(document).on('click', $plp.filter_menu_close, function(){
        $('#bc-sf-filter-tree').removeClass('bc-sf-filter-tree-mobile-open');
    });
}

function update_filter_dom() {
    console.log('hgggygygy');
    var title = $('.plp-hero-info h1').text();
    $('<div class="filter-menu-heading">Filter ' + title + '<span class="filter-menu-close"></span></div>').insertAfter('#bc-sf-filter-tree');
    $('<div class="filter-menu-cta-close">View Results</div>').appendTo('#bc-sf-filter-options-wrapper');
}
